/**
 * 헤더 오른쪽 알약 버튼(재화·로그인·마이) — 높이·세로 가운데·호버를 한 규격으로 맞춘다.
 * cn() 은 클래스를 병합하지 않으므로 좌우 여백은 여기 두지 않고 쓰는 쪽이 정한다(겹치면 어느 쪽이 이길지 모른다).
 */
export const PILL =
  'inline-flex h-8 flex-none cursor-pointer items-center rounded-full border border-white/10 bg-white/[0.04] text-c13 leading-none font-bold whitespace-nowrap tabular-nums transition-colors duration-150 hover:border-white/20 hover:bg-white/[0.08] focus-visible:border-white/40 active:bg-white/[0.1]'

/**
 * 알약 안 재화 아이콘 — 숫자(13px 굵게)의 키에 맞춘 크기. 15px 이상이면 아이콘이 숫자보다 커 보여 한쪽으로 쏠려 보였다.
 * 아이콘과 숫자 사이는 쓰는 쪽에서 gap-1(4px)로 붙인다.
 * 재화 알약은 pb-0.125(0.5px)를 더한다 — Pretendard 숫자·아이콘 묶음이 같은 가운데 정렬이어도 0.5px 낮게 앉았다(캡처 실측). 1px 이면 반대로 0.5px 뜬다.
 */
export const PILL_ICON = 'text-c14'

/** 헤더의 아이콘 버튼(뒤로·메뉴) — 40px 누름 영역, 호버·포커스는 옅은 원형 면 */
export const ICON_BTN =
  'grid size-10 flex-none cursor-pointer place-items-center rounded-full text-t1 transition-colors duration-150 hover:bg-white/[0.07] focus-visible:bg-white/[0.07] active:bg-white/[0.1]'
